import { jsxs, jsx } from 'react/jsx-runtime';
import { cn } from '../../utils/formatters.js';
import '@radix-ui/react-label';
import './button.js';
import '@radix-ui/react-progress';
import '../../contexts/AppContext.js';
import { Loader2 } from 'lucide-react';
import 'react';
import '../../lib/toast.js';
import './alert.js';
import '@radix-ui/react-avatar';
import './badge.js';
import 'react-day-picker';
import './chart.js';
import '@radix-ui/react-checkbox';
import '@radix-ui/react-collapsible';
import 'cmdk';
import '@radix-ui/react-dialog';
import '@radix-ui/react-popover';
import 'vaul';
import '@radix-ui/react-dropdown-menu';
import './radio-group.js';
import '@radix-ui/react-select';
import '@radix-ui/react-separator';
import './sidebar.js';
import 'react-toastify';
import '@radix-ui/react-switch';
import '@radix-ui/react-tabs';
import '@radix-ui/react-tooltip';
import 'react-router-dom';
import '../page-layout/FormPageLayout.js';
import '../form/RichTextEditor.js';
import '../../contexts/OrganizationContext.js';
import 'axios';
import '@tanstack/react-query';
import '../crud/CrudDetailView.js';
import '../crud/CrudFormView.js';
import '../../contexts/SidebarContext.js';
import '../../contexts/ThemeContext.js';
import '@dnd-kit/core';
import '@dnd-kit/sortable';
import '@dnd-kit/utilities';

const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-6 w-6',
    lg: 'h-8 w-8',
    xl: 'h-12 w-12',
};
const textSizeClasses = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg',
    xl: 'text-xl',
};
function Loading({ className, size = 'md', text = 'Loading...', fullScreen = false, }) {
    const content = (jsxs("div", { className: cn('flex flex-col items-center justify-center space-y-3', fullScreen ? 'min-h-screen' : 'py-8', className), children: [jsx(Loader2, { className: cn('animate-spin text-primary', sizeClasses[size]) }), text && (jsx("p", { className: cn('text-muted-foreground animate-pulse', textSizeClasses[size]), children: text }))] }));
    if (fullScreen) {
        return jsx("div", { className: "fixed inset-0 bg-background/80 backdrop-blur-xs z-50", children: content });
    }
    return content;
}
// Inline spinner for buttons or small spaces
function LoadingSpinner({ className, size = 'sm', }) {
    return jsx(Loader2, { className: cn('animate-spin', sizeClasses[size], className) });
}

export { Loading, LoadingSpinner };
//# sourceMappingURL=loading.js.map
